// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Gk","dark":"i_Gl","light":"i_Gm","checked":"i_Gn","label":"i_Go","icon":"i_Gp"};